import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

export default class SwitchOnOffToggle extends Component {

    static propTypes = {
        isSwitchOn: PropTypes.bool,
        onToggle:   PropTypes.func,
        labelI18n:  PropTypes.string,
        isDisabled: PropTypes.bool
    };

    constructor(props) {
        super(props);

        this.state = {
            isSwitchOn: this.props.isSwitchOn
        };

        this.toggleOnOff = this.toggleOnOff.bind(this);
    }

    toggleOnOff() {
        this.setState({isSwitchOn: !this.state.isSwitchOn});

        if (this.props.onToggle) {
            this.props.onToggle();
        }

    }

    render() {
        return (
            <div className={"on-off-toggle" + (this.props.isDisabled ? ' disabled ' : ' ') +
            (this.state.isSwitchOn ? "active" : "inactive")}>
                <div className={"on-off-toggle__slider" + (this.state.isSwitchOn ? " active" : " inactive")}
                     onClick={this.toggleOnOff}>
                    <div id={this.props.labelId ? this.props.labelId : null}
                         className="on-off-toggle__slider--label">
                        {this.props.labelI18n ? <FormattedMessage id={this.props.labelI18n} /> : null}
                    </div>
                </div>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/scripts/reusable/Form/SwitchOnOffToggle.jsx